<template>
  <div class="webcam-booth">
    <div v-if="loading">Loading...</div>
    <video ref="webcamStream" id="video" class="webcam"></video>
    <div>
      <button @click="cancel">Back</button>
      <button @click="takePhoto">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 800,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.activateWebcam();
  },
  methods: {
    async activateWebcam() {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false,
      });
      const video = this.$refs.webcamStream;
      video.srcObject = stream;
      video.addEventListener(
        "canplay",
        () => {
          const width = this.size;
          const height = this.size;
          let scale = 0.5;
          if (video.videoWidth * scale < width) {
            scale = width / video.videoWidth;
          }

          if (video.videoHeight * scale < height) {
            scale = height / video.videoHeight;
          }

          const scaledVideoHeight = video.videoHeight * scale;
          const scaledVideoWidth = video.videoWidth * scale;

          video.setAttribute("width", scaledVideoWidth);
          video.setAttribute("height", scaledVideoHeight);
        },
        false
      );
      await video.play();
      this.loading = false;
    },
    cancel() {
      console.log("Cancel");
      this.$emit("cancel");
    },
    takePhoto() {
      if (this.loading) return;
      const canvas = document.createElement("canvas");
      canvas.setAttribute("width", this.size);
      canvas.setAttribute("height", this.size);
      const video = this.$refs.webcamStream;
      const context = canvas.getContext("2d");
      const width = canvas.width;
      const height = canvas.height;

      let scale = 0.5;
      if (video.videoWidth * scale < width) {
        scale = width / video.videoWidth;
      }

      if (video.videoHeight * scale < height) {
        scale = height / video.videoHeight;
      }

      const scaledVideoHeight = video.videoHeight * scale;
      const scaledVideoWidth = video.videoWidth * scale;

      context.translate(context.canvas.width, 0);
      context.scale(-1, 1);
      context.drawImage(
        this.$refs.webcamStream,
        (scaledVideoWidth - width) * -0.5,
        (scaledVideoHeight - height) * -0.5,
        scaledVideoWidth,
        scaledVideoHeight
      );

      this.$emit("photo", canvas.toDataURL("image/png"));
    },
  },
};
</script>

<style lang="scss" scoped>
.webcam-booth {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.webcam {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transform: rotateY(180deg);
}
</style>
